import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {FetchPosts_Parameters} from "../components/api.ts";

import type {feedbackQuery} from "./__graphql-types__/feedbackQuery.ts";

// NOTE: hardcoded `answersLimit` in query. We are now returning 1 answer per
// question for initial discussion load, and the rest with a separate query.
export const FEEDBACK_QUERY: GqlOperation<
    feedbackQuery,
    FetchPosts_Parameters
> = gqlOp(gql`
    query feedbackQuery(
        $topicId: String!
        $focusKind: String!
        $cursor: String
        $limit: Int
        $feedbackType: FeedbackType!
        $currentSort: Int
        $qaExpandKey: String
    ) {
        feedback(
            focusId: $topicId
            cursor: $cursor
            limit: $limit
            feedbackType: $feedbackType
            focusKind: $focusKind
            sort: $currentSort
            qaExpandKey: $qaExpandKey
            answersLimit: 1
        ) {
            feedback {
                isLocked
                isPinned
                replyCount
                appearsAsDeleted
                author {
                    id
                    kaid
                    nickname
                    avatar {
                        name
                        imageSrc
                    }
                }
                badges {
                    name
                    icons {
                        smallUrl
                    }
                    description
                }
                content
                date
                definitelyNotSpam
                deleted
                downVoted
                expandKey
                feedbackType
                flaggedBy
                flaggedByUser
                flags
                focusUrl
                focus {
                    kind
                    id
                    translatedTitle
                    relativeUrl
                }
                fromVideoAuthor
                key
                lowQualityScore
                notifyOnAnswer
                permalink
                qualityKind
                replyCount
                replyExpandKeys
                showLowQualityNotice
                sumVotesIncremented
                upVoted
                ... on QuestionFeedback {
                    hasAnswered
                    answers {
                        isLocked
                        isPinned
                        replyCount
                        appearsAsDeleted
                        author {
                            id
                            kaid
                            nickname
                            avatar {
                                name
                                imageSrc
                            }
                        }
                        badges {
                            name
                            icons {
                                smallUrl
                            }
                            description
                        }
                        content
                        date
                        definitelyNotSpam
                        deleted
                        downVoted
                        expandKey
                        feedbackType
                        flaggedBy
                        flaggedByUser
                        flags
                        focusUrl
                        focus {
                            kind
                            id
                            translatedTitle
                            relativeUrl
                        }
                        fromVideoAuthor
                        key
                        lowQualityScore
                        notifyOnAnswer
                        permalink
                        qualityKind
                        replyCount
                        replyExpandKeys
                        showLowQualityNotice
                        sumVotesIncremented
                        upVoted
                    }
                    isOld
                    answerCount
                }
                ... on AnswerFeedback {
                    question {
                        isLocked
                        isPinned
                        replyCount
                        appearsAsDeleted
                        author {
                            id
                            kaid
                            nickname
                            avatar {
                                name
                                imageSrc
                            }
                        }
                        badges {
                            name
                            icons {
                                smallUrl
                            }
                            description
                        }
                        content
                        date
                        definitelyNotSpam
                        deleted
                        downVoted
                        expandKey
                        feedbackType
                        flaggedBy
                        flaggedByUser
                        flags
                        focusUrl
                        focus {
                            kind
                            id
                            translatedTitle
                            relativeUrl
                        }
                        fromVideoAuthor
                        key
                        lowQualityScore
                        notifyOnAnswer
                        permalink
                        qualityKind
                        replyCount
                        replyExpandKeys
                        showLowQualityNotice
                        sumVotesIncremented
                        upVoted
                    }
                }
            }
            cursor
            isComplete
            sortedByDate
        }
    }
`);
